import React from "react";

export default class Psychotic extends React.Component {
  render() {
    return (
      <>
        <p>
          Most commonly caused by multiday runs on stimulants, in effect of
          sleep deprivation and lack of regeneration of body and mind.
        </p>
        <h3>Symptoms:</h3>
        <p>
          Delusions of reference (a person percieves, that everyone is talking
          about and looking at her/him, that everyone knows, about the drugs
          taken), visual and auditory delusions, paranoia about being
          persecuted, followed or listened to.
        </p>
        <h3>What to do?</h3>
        <ul>
          <li>
            Try to calm down the person and explain, that this is a natural body
            and brain reaction to the lack of sleep and fatigue, and that
            everyone who pulls an allnighters experienecs these symptoms sooner
            or later (and certainly is not the only person affected by that).
            Try to convince the person to attempt sleep, argumenting that all
            the symptoms will go away after a couple hours of sleep.
          </li>
          <li>
            Find something that will help calm down and get some sleep, like
            i.e. change of the environment, warm drinks, trusted people. If
            psychosis lats too long and is difficult to control, conctant with
            the person is difficult and illogical, or the person begins to
            threaten themselve or sorrounding through own irrational behavior,
            consider calling a medical rescue team.
          </li>
          <li>
            Do not let the person to ingest any more psychoactive substances.
            Only medical rescue team or a doctor can administer correct drugs,
            that will controll a person in psychosis.
          </li>
        </ul>
      </>
    );
  }
}
